import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { DocumentTextIcon } from '@heroicons/react/24/outline';

/**
 * Link-styled controls matching the shared LinkButton look. The shared
 * LinkButton cannot take an aria-label or open a new tab, which these need.
 */
export const linkClassName = classNames(
  'inline-flex items-center gap-1 py-1 rounded whitespace-nowrap',
  'text-[17px] leading-6 font-normal text-cs-blue-600',
  'hover:underline active:text-cs-blue-600',
  'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-black focus-visible:ring-offset-2'
);

/** "Watch" on the compact row cards. The card's click handler opens the video. */
WatchTextButton.propTypes = {
  label: PropTypes.string.isRequired,
  ariaLabel: PropTypes.string.isRequired
};

export function WatchTextButton(props) {
  const { label, ariaLabel } = props;
  return (
    <button type="button" aria-label={ariaLabel} className={linkClassName}>
      {label}
    </button>
  );
}

/**
 * An external link that opens in a new tab, e.g. the featured card's
 * resource link or the resource card's "Open". `truncate` keeps a long
 * label (a resource title) on one line with an ellipsis; the full text stays
 * in the accessible name and shows on hover.
 */
NewTabLink.propTypes = {
  href: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  ariaLabel: PropTypes.string.isRequired,
  withIcon: PropTypes.bool,
  truncate: PropTypes.bool
};

export function NewTabLink(props) {
  const { href, label, ariaLabel, withIcon = false, truncate = false } = props;
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={ariaLabel}
      title={truncate ? label : undefined}
      className={classNames(linkClassName, 'relative', truncate && 'min-w-0 max-w-full')}
    >
      {withIcon && <DocumentTextIcon className="size-6 flex-shrink-0" aria-hidden="true" />}
      <span className={classNames(truncate && 'truncate')}>{label}</span>
    </a>
  );
}
